import React from "react";
import "./style.scss";
import copyIcon from "../../../../assets/icons/copy-white.svg";
import Spinner from "../../../../reusableComponents/spinner/Spinner";
import CopyToClipboard from "react-copy-to-clipboard";
import toast from "react-hot-toast";

function GenerateCoupon({ formik, createdLink }) {
  return (
    <div className="generate-coupon box">
      <h2 className="component-heading">Generate Your Coupon Code</h2>

      <div className="gc-inputs-wrapper">
        {/* <div className="input-wrapper">
          <label>Your Unique Coupon Code</label>
          <div>
            <input
              style={{ textTransform: "uppercase" }}
              maxLength={16}
              onChange={(e) => {
                formik.setFieldValue("code", e.target.value.toUpperCase());
              }}
              value={formik.values.code}
              type="text"
              placeholder="Coupon code"
            />
            <CopyToClipboard
              text={formik.values.code}
              onCopy={() =>
                formik.values.code && toast.success("Affiliate code copied!")
              }
            >
              <img src={copyIcon} alt="" style={{ cursor: "pointer" }} />
            </CopyToClipboard>
          </div>
        </div>
        {formik.touched.code && formik.errors.code && (
          <div className="form-error-message">{formik.errors.code}</div>
        )} */}

        <div className="input-wrapper">
          <label>Affiliate Link</label>
          <div>
            <input
              type="text"
              value={createdLink.url}
              placeholder="Affiliate Link"
              disabled
            />
            <CopyToClipboard
              text={createdLink.url}
              onCopy={() =>
                createdLink.url && toast.success("Affiliate link copied!")
              }
            >
              <p className="table_copy_button" style={{ cursor: "pointer" }}>
                <img src={copyIcon} alt="" />
              </p>
            </CopyToClipboard>{" "}
          </div>
        </div>
      </div>

      <div className="note">
        <p>NOTE: Fixed Commission Income rates for company is 15%</p>
      </div>
      <button className="standard-button" onClick={formik.handleSubmit}>
        {formik.isSubmitting ? <Spinner /> : "Generate"}
      </button>
    </div>
  );
}

export default GenerateCoupon;
